import { useRef } from 'react';
import usePostData from '../../../../../hooks/postHook';
import { referencePayloadFormat } from '../../../features_public/reference_index/api/createReference';
import { referenceIndexKeys } from '../../../features_public/reference_index/controllers/variables';

export const useUpdateReference = ({
  [referenceIndexKeys.id]: referenceId,
  isAdmin,
}) => {
  const actionsRef = useRef({});

  const [{ body, isLoading, isError, error }, doUpdate_] = usePostData(
    `${isAdmin ? 'admin_' : ''}reference/${referenceId}`,
    { type: 'put' }
  );

  const doUpdate = (values, actions) => {
    const body = referencePayloadFormat(values);
    actionsRef.current = actions;
    doUpdate_(body);
  };

  return {
    isLoading,
    isError: body?.name?.includes('error'),
    error,
    actions: actionsRef.current,
    body,
    doUpdate,
  };
};
